import React from "react";
import { useHistory } from "react-router-dom";
import { taskTypeIcon } from "Static/constant";
import LinearLoader from "./LinearLoader";

const TasksWidget = ({ tasks = [], isLoading = false }) => {
  const history = useHistory();

  if (isLoading) {
    return <LinearLoader visible={true} />;
  }

  if (!tasks.length) {
    return (
      <div className="taskWidgetEmpty">
        <p>No tasks found.</p>
        <button
          type="button"
          className="taskWidgetGoBtn"
          onClick={() => history.push("/tasks")}
        >
          Go to Tasks
        </button>
      </div>
    );
  }

  return (
    <div className="taskWidgetWrap">
      <div className="taskWidgetList">
        {tasks.map((item, idx) => {
          const { id, taskType } = item?.task || {};
          const { firstName = "", email = "" } = item?.contact || {};
          const icon = taskTypeIcon[taskType]?.icon || null;

          return (
            <div
              key={id || idx}
              className="taskWidgetRow"
              onClick={() => id && history.push(`/tasks/start/${id}`)}
            >
              <div className="taskWidgetIcon taskTypeWrapper">{icon}</div>
              <div className="taskWidgetInfo">
                <span className="taskWidgetName">{firstName || "—"}</span>
                <span className="taskWidgetEmail">{email || ""}</span>
              </div>
            </div>
          );
        })}
      </div>
      <button
        type="button"
        className="taskWidgetGoBtn"
        onClick={() => history.push("/tasks")}
      >
        Go to Tasks
      </button>
    </div>
  );
};

export default TasksWidget;
